/* The banner that says the connection went, and what is waiting because of it.
 *
 * Two things a person needs to know when the signal drops in a warehouse:
 * that it dropped, and that what they typed is not lost. Both, in one line,
 * and it goes away by itself when the work has gone out.
 */
import { useCallback, useEffect, useState } from 'react'
import { useErp } from '@jackdesk/erp-kit'
import { Offline, useOnline, useToast } from '@jackdesk/shell'

export function Connection() {
  const erp = useErp()
  const online = useOnline()
  const toast = useToast()
  const [waiting, setWaiting] = useState(0)
  const [sending, setSending] = useState(false)

  const count = useCallback(() => setWaiting(erp.outbox().length), [erp])

  useEffect(() => {
    count()
    // Cheap, and the outbox changes from anywhere in the app.
    const timer = window.setInterval(count, 4000)
    return () => window.clearInterval(timer)
  }, [count])

  // Back on the network: send what is waiting, oldest first.
  useEffect(() => {
    if (!online || !erp.outbox().length || sending) return
    setSending(true)
    erp.flushOutbox()
      .then(({ sent, left, failed }) => {
        if (sent) toast('ok', `${sent} thing${sent === 1 ? '' : 's'} you did offline went out.`)
        if (left && failed) toast('error', `${left} still waiting: ${failed}`)
        count()
      })
      .finally(() => setSending(false))
  }, [online, erp, toast, count, sending])

  if (online && !waiting) return null

  return (
    <div className="page" style={{ paddingBottom: 0 }} data-part="connection">
      {!online ? (
        <Offline />
      ) : (
        <div className="card card-pad small" role="status">
          {sending ? 'Sending what you did offline…' : `${waiting} thing${waiting === 1 ? '' : 's'} `
            + 'you did offline are waiting to go out.'}
        </div>
      )}
    </div>
  )
}
